<template>
  <div class="form-container">
    <div v-if="loading" class="loading-overlay">
      <b-spinner
        label="Loading..."
        variant="primary"
        class="spinner"
      ></b-spinner>
    </div>
    <h2>{{ title }}</h2>

    <div class="form-group-custom">
      <label
        >Do you require business financials for eligibility? (e.g., Last 2 Years
        of Tax Returns)</label
      >
      <HiloSelect
        id="businessFinancials"
        :theme="'grey'"
        v-model="form.businessFinancials"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Choose one...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom">
      <label>Do you require proof of ownership for the flight school?</label>
      <HiloSelect
        id="proofOfOwnership"
        :theme="'grey'"
        v-model="form.proofOfOwnership"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Choose one...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom">
      <label for="minimum-tuition-required"
        >What is the minimum tuition amount required for financing to be
        offered?</label
      >
      <input
        type="number"
        id="minimum-tuition-required"
        v-model="form.minimumTuitionAmount"
        placeholder="Type your answer..."
      />
    </div>

    <div class="form-group-custom">
      <label for="maximum-tuition-required"
        >What is the maximum tuition amount you will finance?</label
      >
      <input
        type="number"
        id="maximum-tuition-required"
        v-model="form.maximumTuitionAmount"
        placeholder="Type your answer..."
      />
    </div>

    <div class="form-group-custom">
      <label for="number-of-students"
        >What is the minimum number of students required for a flight school to
        qualify?</label
      >
      <input
        type="number"
        id="number-of-students"
        v-model="form.minimumStudentsRequired"
        placeholder="Type your answer..."
      />
    </div>

    <div class="form-group-custom">
      <label>What documents are required for the application process?</label>
      <HiloSelect
        id="requiredFlightSchoolDocumentations"
        :theme="'grey'"
        multi-select
        v-model="form.requiredFlightSchoolDocumentations"
        :options="requiredDocumentationsList"
        :placeholder="'Select all that apply...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom">
      <label
        >Do you offer financing for specific programs only (e.g., Private Pilot,
        CFI)?</label
      >
      <HiloSelect
        id="financingPrograms"
        :theme="'grey'"
        v-model="form.financingPrograms"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Choose one...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div v-if="form.financingPrograms === true" class="form-group-custom">
      <label>List programs</label>
      <input
        type="text"
        id="list-programs"
        v-model="form.listPrograms"
        placeholder="List programs"
      />
    </div>

    <div class="form-group-custom">
      <label
        >Do you provide loan terms based on flight school size or
        revenue?</label
      >
      <HiloSelect
        id="provideLoanTerms"
        :theme="'grey'"
        v-model="form.provideLoanTerms"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Choose one...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom">
      <label
        >Do you have additional requirements for international student
        eligibility?</label
      >
      <HiloSelect
        id="additionalRequirements"
        :theme="'grey'"
        v-model="form.additionalRequirements"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Choose one...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div v-if="form.additionalRequirements === true" class="form-group-custom">
      <label>Specify requirements</label>
      <input
        type="text"
        id="specify-requirements"
        v-model="form.specifyRequirements"
        placeholder="Specify requirements..."
      />
    </div>

    <div class="form-group-custom">
      <label>Do you require TSA compliance for international students?</label>
      <HiloSelect
        id="requireTSA"
        :theme="'grey'"
        v-model="form.requireTSA"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Choose one...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom">
      <label>Do you require pre-qualification checks for flight schools?</label>
      <HiloSelect
        id="requirePreQualification"
        :theme="'grey'"
        v-model="form.requirePreQualification"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Choose one...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div class="form-group-custom">
      <label
        >Do you require a specific number of aircraft in the flight school’s
        fleet?</label
      >
      <HiloSelect
        id="requireAircraftNumber"
        :theme="'grey'"
        v-model="form.requireAircraftNumber"
        :options="[
          { id: true, name: 'Yes' },
          { id: false, name: 'No' },
        ]"
        :placeholder="'Choose one...'"
        :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
      />
    </div>

    <div v-if="form.requireAircraftNumber === true" class="form-group-custom">
      <label>Specify fleet size</label>
      <input
        type="number"
        id="fleet-size-requirements"
        v-model="form.specifyFleetSizeRequirements"
        placeholder="Specify fleet size requirements..."
      />
    </div>

    <div class="buttonContainer">
      <div class="nextButton" @click="onNext">
        <b class="name">Next</b>
      </div>
      <div class="backButton" @click="$emit('onPrev')">
        <b class="name">Back</b>
      </div>
    </div>
  </div>
</template>
<script>
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import AboutYouAPIService from "@/servicehandlers/AboutYouAPIService";
const aboutYouAPIService = new AboutYouAPIService();
import get from "lodash/get";

export default {
  components: { HiloSelect },
  props: {
    title: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
    lenderId: {
      type: Number,
    },
  },
  data() {
    return {
      form: {
        businessFinancials: "",
        proofOfOwnership: "",
        minimumTuitionAmount: "",
        maximumTuitionAmount: "",
        minimumStudentsRequired: "",
        requiredFlightSchoolDocumentations: [],
        financingPrograms: "",
        listPrograms: "",
        provideLoanTerms: "",
        additionalRequirements: "",
        specifyRequirements: "",
        requireTSA: "",
        requirePreQualification: "",
        requireAircraftNumber: "",
        specifyFleetSizeRequirements: "",
      },
      requiredDocumentationsList: [],
      loading: false,
    };
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getRequiredDocumentationList();
      await this.getFlightSchoolCriteriaSavedData();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async getRequiredDocumentationList() {
      try {
        const list = await aboutYouAPIService.getRequiredDocumentationsList();
        this.requiredDocumentationsList = list.filter((rd) => rd.flightSchool);
      } catch (error) {}
    },
    async getFlightSchoolCriteriaSavedData() {
      if (this.lenderId) {
        try {
          const fetchedData = await aboutYouAPIService.getLenderById(
            this.lenderId,
          );
          if (fetchedData) {
            this.form = { ...this.form, ...fetchedData };
          }
        } catch (error) {}
      }
    },
    async onNext() {
      const validations = [
        { field: "businessFinancials", desc: "require business financials" },
        { field: "proofOfOwnership", desc: "require proof of ownership" },
        { field: "minimumTuitionAmount", desc: "minimum tuition amount" },
        { field: "maximumTuitionAmount", desc: "maximum tuition amount" },
        {
          field: "minimumStudentsRequired",
          desc: "minimum number of students required",
        },
        {
          field: "requiredFlightSchoolDocumentations",
          desc: "documents required for application",
        },
        {
          field: "financingPrograms",
          desc: "offer financing for specific programs",
          type: "required",
        },
        {
          field: "listPrograms",
          desc: "list of specific programs",
          type: "specify",
          condition: () => this.form.financingPrograms === true,
        },
        {
          field: "provideLoanTerms",
          desc: "loan terms based on school size or revenue",
        },
        {
          field: "additionalRequirements",
          desc: "additional requirements for international students",
          type: "required",
        },
        {
          field: "specifyRequirements",
          desc: "specify additional requirements",
          type: "specify",
          condition: () => this.form.additionalRequirements === true,
        },
        { field: "requireTSA", desc: "tsa compliance requirement" },
        {
          field: "requirePreQualification",
          desc: "pre-qualification check requirement",
        },
        {
          field: "requireAircraftNumber",
          desc: "specific number of aircraft requirement",
          type: "required",
        },
        {
          field: "specifyFleetSizeRequirements",
          desc: "specify fleet size requirements",
          type: "specify",
          condition: () => this.form.requireAircraftNumber === true,
        },
      ];

      let missingFields = [];

      for (const { field, desc, type, condition } of validations) {
        if (condition && !condition()) {
          continue;
        }

        const fieldValue = get(this.form, field);
        if (type === "required") {
          if (
            fieldValue === undefined ||
            fieldValue === null ||
            fieldValue === ""
          ) {
            missingFields.push(desc);
          }
          continue;
        }

        if (
          type === "specify" &&
          (fieldValue === false ||
            fieldValue === undefined ||
            fieldValue === null)
        ) {
          continue;
        }

        if (
          fieldValue === undefined ||
          fieldValue === null ||
          fieldValue === "" ||
          (Array.isArray(fieldValue) && fieldValue.length === 0)
        ) {
          missingFields.push(desc);
        }
      }

      if (missingFields.length > 0) {
        alert(
          `Please enter the following required fields:\n- ${missingFields.join("\n- ")}`,
        );
        return;
      }

      if (this.form.minimumTuitionAmount > this.form.maximumTuitionAmount) {
        alert(
          "Minimum tuition cannot be more than the maximum tuition.",
        );
        return;
      }

      try {
        this.loading = true;
        const flightSchoolCriteriaData = {
          ...this.form,
          lenderId: this.lenderId,
          userId: this.userId,
        };
        await aboutYouAPIService.createOrUpdateLender(flightSchoolCriteriaData);
        this.$emit("onNext", { flightSchoolCriteria: this.form });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}
</style>
